import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  private version: string = '2.0.0'; // Default fallback version

  constructor() {
    this.loadVersionFromPackageJson();
  }

  private async loadVersionFromPackageJson(): Promise<void> {
    try {
      // In a real app, you would fetch this from package.json during build
      // For now, we'll use the version from package.json that was set during build
      // This could be injected during the build process
      // Add timestamp to prevent caching
      const response = await fetch(`/assets/version.json?t=${new Date().getTime()}`);
      if (response.ok) {
        const versionData = await response.json();
        this.version = versionData.version;
      }
    } catch (error) {
      console.warn(
        'Could not load version from assets, using default:',
        this.version
      );
    }
  }

  getVersion(): string {
    return this.version;
  }

  getVersionDisplay(): string {
    return `v${this.version}`;
  }

  getMajorVersion(): number {
    const majorVersion = parseFloat(this.version.split('.')[0]);
    return isNaN(majorVersion) ? 1 : majorVersion;
  }

  getMinorVersion(): number {
    const minorVersion = parseFloat(this.version.split('.')[1]);
    return isNaN(minorVersion) ? 0 : minorVersion;
  }

  getPatchVersion(): number {
    const patchVersion = parseFloat(this.version.split('.')[2]);
    return isNaN(patchVersion) ? 0 : patchVersion;
  }
}
